import { useEffect, useState } from 'react'
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { formatDate, formatTo0Decimal, getFontSize, getSpecList, isEmpty, isNotEmpty } from '../../common/util.services';
import { LOGO } from '../../common/constants';

const PrintPojo = (props: any) => {
  let pojoData = props.data;
  const styles = StyleSheet.create({
    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },
    spaceBetween: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: "#3E3E3E" },
    titleContainer: { flexDirection: 'row', marginTop: 15 },
    theader: { marginTop: 20, fontSize: 10, fontStyle: 'normal', paddingTop: 4, paddingLeft: 7, flex: 1, fontWeight: 'bold',
               borderColor: 'black', borderWidth: 0.5 },
    theader2: { flex: 3, borderWidth: 0.5, borderColor: 'black' },
    tbody: { fontSize: 9, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'black', borderWidth: 0.5 },
    total: { fontSize: 9, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'black', borderWidth: 0.5 },
    total2: { flex: 3, borderWidth: 0.5, borderColor: 'black' },
    tbody2: { flex: 3, borderWidth: 0.5, borderColor: 'black'}
  });

  const [specList, setSpecList] = useState<any>([]);
    
  useEffect(() => {
    let data = {type: pojoData.inputType, input: pojoData.inputName};
    setSpecList(getSpecList(data));
  }, []);

  function getSpecValue(inputSpec: any) {
    switch (inputSpec){
      case 'spec1': return pojoData.spec1;
      case 'spec2': return pojoData.spec2;
      case 'spec3': return pojoData.spec3;
      case 'spec4': return pojoData.spec4;
      case 'spec5': return pojoData.spec5;
      case 'spec6': return pojoData.spec6;
      case 'spec7': return pojoData.spec7;
      case 'spec8': return pojoData.spec8;
      case 'spec9': return pojoData.spec9;
      case 'spec10': return pojoData.spec10;
      case 'spec11': return pojoData.spec11;
      case 'spec12': return pojoData.spec12;
      case 'spec13': return pojoData.spec13;
      case 'spec14': return pojoData.spec14;
      case 'spec15': return pojoData.spec15;
      default: return '';
    }
  }

  function getSpec(inputSpec: any) {
    let specName = '';
    specList.map((spec: any) => {
      if(inputSpec === spec.fieldObject) {
        specName = spec.fieldName;
      }
    });

    let specValue = getSpecValue(inputSpec);
    return isEmpty(specValue) || 'NA' === specValue ? '' : specName + ' : ' + specValue;
  }

  const Header = () => (
    <View style={styles.titleContainer}>
      <View>
        <Image style={{width: 90}} src={LOGO} />
      </View>
      <View style={{position: 'absolute', left: 0, right: 0, alignItems: 'center', justifyContent: 'center', zIndex: -1}}>
        <Text style={{fontSize: 14, textAlign: 'center', fontWeight: 'bold'}}>
          {'Purchase Order' === pojoData.pojoType ? 'PURCHASE ORDER' : 'JOB ORDER'}
        </Text>
      </View>
    </View>
  );

  const InvoiceDetails = () => (
    <View style={styles.titleContainer}>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Invoice To</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>LFH Home Private Limited</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>40-D, Periyar Nagar 2nd Cross</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>Sengunthapuram PO, Karur</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>Tamil Nadu, 639002</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>GSTIN: 33AAECL3320P1ZI</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60, fontWeight: 'bold'}}>Consignee (Ship To)</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>LFH Home Private Limited</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>40-D, Periyar Nagar 2nd Cross</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>Sengunthapuram PO, Karur</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>Tamil Nadu, 639002</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>GSTIN: 33AAECL3320P1ZI</Text>
      </View>
      <View style={{marginLeft: 60}}>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Supplier (Bill From)</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.supplier}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.address1}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.address2}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.address3}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{'GSTIN: ' + pojoData.gstin}</Text>
      </View>
    </View>
  );

  const OtherDetails = () => (
    <View style={styles.titleContainer}>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>
          {'Purchase Order' === pojoData.pojoType ? 'PO No.' : 'JO No.'}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.pojoCode}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Payment Mode</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.paymentMode}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Transport Mode</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.transportMode}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>
          {'Purchase Order' === pojoData.pojoType ? 'PO Date' : 'JO Date'}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>{formatDate(pojoData.poDate)}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>Reference</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>{pojoData.reference}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>Destination</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>{pojoData.destination}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>Terms Of Delivery</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm1) ? '- ' + pojoData.deliveryTerm1 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm2) ? '- ' + pojoData.deliveryTerm2 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm3) ? '- ' + pojoData.deliveryTerm3 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm4) ? '- ' + pojoData.deliveryTerm4 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm5) ? '- ' + pojoData.deliveryTerm5 : ''}
        </Text>
      </View>
    </View>
  );

  const TableHead = () => (
    <View style={{ width: '100%', flexDirection: 'row'}}>
      <View style={[styles.theader, styles.theader2]}>
        <Text>Description</Text>
      </View>
      <View style={styles.theader}>
        <Text>Delivery Date</Text>
      </View>
      <View style={styles.theader}>
        <Text>Quantity</Text>
      </View>
      <View style={styles.theader}>
        <Text>Rate</Text>
      </View>
      <View style={styles.theader}>
        <Text>Amount</Text>
      </View>
    </View>
  );

  const TableBody = () => (
    <View style={{ width: '100%', flexDirection: 'row' }}>
      <View style={[styles.tbody, styles.tbody2]}>
        <Text style={{fontWeight: "bold"}}>
          {pojoData.inputName + ('Purchase Order' !== pojoData.pojoType ? '' : ' (HSN Code - ' + 
                                 (isNotEmpty(pojoData.hsnCode) ? pojoData.hsnCode : 'NA') + ')')}
        </Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{'Code : ' + pojoData.inputCode}</Text>
        <Text style={{marginLeft: 10, fontWeight: 'bold', fontStyle: 'italic', fontSize: getFontSize('Desc : ' + pojoData.description)}}>
          {'Desc : ' + pojoData.description}</Text>
        {isNotEmpty(pojoData.sku) && 'NA' !== pojoData.sku && <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{'SKU : ' + pojoData.sku}</Text>}
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec1'))}}>{getSpec('spec1')}</Text>
        {'Fabric' === pojoData.inputName && 
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec15'))}}>{getSpec('spec15')}</Text>}
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec2'))}}>{getSpec('spec2')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec3'))}}>{getSpec('spec3')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec4'))}}>{getSpec('spec4')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec5'))}}>{getSpec('spec5')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec6'))}}>{getSpec('spec6')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec7'))}}>{getSpec('spec7')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec8'))}}>{getSpec('spec8')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec9'))}}>{getSpec('spec9')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec10'))}}>{getSpec('spec10')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec11'))}}>{getSpec('spec11')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec12'))}}>{getSpec('spec12')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec13'))}}>{getSpec('spec13')}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec14'))}}>{getSpec('spec14')}</Text>
        {'Fabric' !== pojoData.inputName && 
        <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec('spec15'))}}>{getSpec('spec15')}</Text>}
      </View>
      <View style={styles.tbody}>
        <Text>{formatDate(pojoData.deliveryDate)} </Text>
      </View>
      <View style={styles.tbody}>
        <Text>{formatTo0Decimal(getPlannedOutput()) + ' ' + getOutputUom()}</Text>
      </View>
      <View style={styles.tbody}>
        <Text>{pojoData.printCurrency + getUnitCost().toFixed(2) + ' / ' + getOutputUom()}</Text>
      </View>
      <View style={[styles.tbody, {fontWeight: "bold"}]}>
        <Text>{pojoData.printCurrency + formatTo0Decimal(getPOValue())}</Text>
      </View>
    </View>
  );

  function getGSTText(value: any) {
    return isEmpty(value) ? '' : value + '%';
  }

  function calculateGST(cost: any, gst: any) {
    return isEmpty(gst) ? 0 : Math.ceil(cost * gst/100);
  }

  function getUnitCost() {
    return pojoData.printUnitCost;
  }

  function getPlannedOutput() {
    return pojoData.printOutput;
  }

  function getOutputUom(){
    return pojoData.printUom;
  }

  function getPOValue() {
    return Math.ceil(getUnitCost() * getPlannedOutput());
  }

  const TableTotal = () => (
    <View style={{ width: '100%', flexDirection: 'row' }}>
      <View style={[styles.total, styles.total2]}>
        <Text style={{fontWeight: 'bold', marginLeft: 175, fontStyle: "italic"}}>{isEmpty(pojoData.cgst) ? '' : 'CGST'}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 175, fontStyle: "italic"}}>{isEmpty(pojoData.sgst) ? '' : 'SGST'}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 175, fontStyle: "italic"}}>{isEmpty(pojoData.igst) ? '' : 'IGST'}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 175}}>Total</Text>
      </View>
      <View style={styles.total}>
        <Text></Text>
      </View>
      <View style={styles.total}>
        <Text></Text>
      </View>
      <View style={styles.total}>
        <Text style={{fontStyle: "italic"}}>{getGSTText(pojoData.cgst)}</Text>
        <Text style={{fontStyle: "italic"}}>{getGSTText(pojoData.sgst)}</Text>
        <Text style={{fontStyle: "italic"}}>{getGSTText(pojoData.igst)}</Text>
      </View>
      <View style={styles.total}>
        <Text style={{fontWeight: 'bold', fontStyle: "italic"}}>
          {isEmpty(pojoData.cgst) ? '' : (pojoData.printCurrency + formatTo0Decimal(calculateGST(getPOValue(), pojoData.cgst)))}
        </Text>
        <Text style={{fontWeight: 'bold', fontStyle: "italic"}}>
          {isEmpty(pojoData.sgst) ? '' : (pojoData.printCurrency + formatTo0Decimal(calculateGST(getPOValue(), pojoData.sgst)))}
        </Text>
        <Text style={{fontWeight: 'bold', fontStyle: "italic"}}>
          {isEmpty(pojoData.igst) ? '' : (pojoData.printCurrency + formatTo0Decimal(calculateGST(getPOValue(), pojoData.igst)))}
        </Text>
        <Text style={{fontWeight: 'bold'}}>
          {pojoData.printCurrency + formatTo0Decimal(getPOValue() + calculateGST(getPOValue(), pojoData.cgst) +
                                                     calculateGST(getPOValue(), pojoData.sgst) +
                                                     calculateGST(getPOValue(), pojoData.igst))}
        </Text>
      </View>
    </View>
  );

  const OtherText = () => (
    <View style={{ width: '100%', flexDirection: 'row'}}>
      <View wrap={false}>
        <Text style={{fontSize: 10, marginTop: 10, fontStyle: 'italic'}}>- This is a computer generated document and signature is not required</Text>
        <Text style={{fontSize: 10, marginTop: 0, fontStyle: 'italic'}}>- All disputes are subject to Karur jurisdiction</Text>
      </View>
      <View wrap={false}>
        <Text style={{fontSize: 10, marginTop: 25, marginLeft: 110}}>Authorised Signatory</Text>
      </View>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header/>
        <InvoiceDetails />
        <OtherDetails />
        <TableHead />
        <TableBody />
        <TableTotal />
        <OtherText />
      </Page>
    </Document>
  )
}

export default PrintPojo